export { LectureSingleFragment } from './lecture-single';
